module.exports = __webpack_public_path__ + "img/3468855.f668da11.svg";